import React, { Fragment, useState } from "react";
import { Tabs, Spin, Alert, Modal, Button, Typography, Space } from "antd";
import styles from "../topology.module.scss";
import {
  StateSIM,
  StateGPSF,
  StatesDNSF,
  StateConnectionF,
  StateTxRxF,
  IdentityTableF,
} from "./DeviceTableF_StateModalF";
import { setDeviceStateVisible, setDeviceRecord } from "../store/topologySlice";
import { useAppSelector, useAppDispatch } from "store/hook";
import { useTranslation } from "react-i18next";
import { useDeviceIdentityByID, useDeviceStatusByID } from "Components/Dashboard/queries";

const { TabPane } = Tabs;
const { Text } = Typography;

const DeviceStateModal = React.memo(() => {
  const disp = useAppDispatch();
  const { t } = useTranslation();
  const { deviceRecord, deviceStateVisible } = useAppSelector((state) => state.topology);
  const { data: deviceIdentityByID, isFetching: deviceIdentityFetching } = useDeviceIdentityByID(
    deviceRecord?.id,
    deviceStateVisible
  );
  const { data: deviceStatusByID, isFetching: deviceStatusFetching } = useDeviceStatusByID(
    deviceRecord?.id,
    deviceStateVisible
  );
  const { isDarkMode } = useAppSelector((state) => state.global);
  const loading = deviceIdentityFetching || deviceStatusFetching;
  const modelHideGPS =
    deviceIdentityByID?.model_name === "M335-W-A" ||
    deviceIdentityByID?.model_name === "M335-W" ||
    deviceIdentityByID?.model_name === "M335-W6";
  const modelHideLTE = deviceIdentityByID?.model_name === "M335-W-A";

  return (
    <Modal
      title={
        <Space>
          <Text>{t("ISMS.Status")} </Text>
          <Text className={styles.titleDevice}> {deviceRecord?.name_or_id}</Text>
        </Space>
      }
      visible={deviceStateVisible}
      onCancel={() => {
        disp(setDeviceStateVisible(false));
        disp(setDeviceRecord({ id: null }));
      }}
      destroyOnClose={true}
      width="70%"
      footer={[
        <Button key="confirm" type="primary" onClick={() => disp(setDeviceStateVisible(false))}>
          {t("ISMS.Confirm")}
        </Button>,
      ]}
    >
      {!loading ? (
        <Tabs defaultActiveKey="statistic" type="card">
          {deviceStatusByID?.status && (
            <Fragment>
              <TabPane tab="Statistic" key="statistic">
                <StateTxRxF
                  deviceStatusByID={deviceStatusByID}
                  deviceIdentityByID={deviceIdentityByID}
                  isDarkMode={isDarkMode}
                  modelHideLTE={modelHideLTE}
                />
              </TabPane>
              <TabPane tab="Connection" key="connection">
                <StateConnectionF deviceStatusByID={deviceStatusByID} />
              </TabPane>
              {deviceIdentityByID?.hardware_mcsv.slice(0, 4) !== "012E" && !modelHideLTE && (
                <TabPane tab="SIM" key="sim">
                  <StateSIM deviceStatusByID={deviceStatusByID} />
                </TabPane>
              )}
              {deviceIdentityByID?.hardware_mcsv.slice(0, 4) !== "012E" && !modelHideGPS && (
                <TabPane tab="GPS" key="gps">
                  <StateGPSF deviceStatusByID={deviceStatusByID} />
                </TabPane>
              )}

              <TabPane tab="DNS" key="dns">
                <StatesDNSF deviceStatusByID={deviceStatusByID} />
              </TabPane>
            </Fragment>
          )}
          {deviceIdentityByID && (
            <TabPane tab="Identity" key="identity">
              <IdentityTableF deviceStatusByID={deviceStatusByID} deviceIdentityByID={deviceIdentityByID} />
            </TabPane>
          )}
        </Tabs>
      ) : (
        <Spin tip="Loading...">
          <Alert message="Getting Data" description="Please Wait" />
        </Spin>
      )}
    </Modal>
  );
});

export default DeviceStateModal;
